var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('IEcharts',{ref:"charts",staticStyle:{"width":"100%","height":"100%"},attrs:{"option":_vm.EventAnalysisOption}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }